import { MessagingService } from './messaging-service'
import { Message } from './message.interface'

const MAX_EVENT_STORAGE: number = 10


export class TrackingFunctions {

    private _trackingBasic: Array<any> = []
    private _trackingCurrent: Array<any> = []
    private _trackingOldvNew: Array<any> = []

    private hasQubitFrameworkLoaded: boolean = false

    constructor() {
        window.addEventListener('qubitTrackingOnLoadEvent', () => this.eventTriggered())
    }

    /**
     * Basic tracking method, takes just a message and sends no other data.
     *
     * @param message - Message to send.
     */
    trackBasic(message: string): void {

        if (this.hasQubitFrameworkLoaded) {
            const messageObj: Message = {
                name: message
            }
            MessagingService.postMessage(messageObj)
        } else {
            this.trackingBasic.push({ trackName: message })
        }
    }

    /**
     * Current tracking allows for a single value to be sent along with the message.
     *
     * @param message - Message to send.
     * @param current - Value to send along with message.
     */
    trackCurrent(message: string, current: any): void {

        if (this.hasQubitFrameworkLoaded) {
            const messageObj: Message = {
                name: message,
                data: current
            }

            MessagingService.postMessage(messageObj)
        } else {
            this.trackingCurrent.push({ trackName: message, trackCurrentValue: current })
        }
    }

    /**
     * Track Old V New allows for an old and new value to passed along with the message.
     *
     * @param message - Message to send.
     * @param previous - Previous value.
     * @param current - Current value.
     */
    trackOldVNew(message: string, previous: any, current: any): void {

        if (this.hasQubitFrameworkLoaded) {
            const messageObj: Message = {
                name: message,
                data: {
                    old: previous,
                    new: current
                }
            }

            MessagingService.postMessage(messageObj)
        } else {
            this.trackingOldNew.push({ trackName: message, trackPreviousValue: previous, trackCurrentValue: current })
        }
    }

    /**
     * Releases stored backlog of tracked events on consumption of event 'qubitTrackingOnLoadEvent' - see the constructor of this
     */
    eventTriggered() {
        this.hasQubitFrameworkLoaded = true

        if (this.trackingBasic.length <= MAX_EVENT_STORAGE) {
            this.trackingBasic.forEach(tracked => this.trackBasic(tracked['trackName']))
        }

        if (this.trackingCurrent.length <= MAX_EVENT_STORAGE) {
            this.trackingCurrent.forEach(tracked => this.trackCurrent(tracked['trackName'], tracked['trackCurrentValue']))
        }

        if (this.trackCurrent.length <= MAX_EVENT_STORAGE) {
            this.trackingOldNew.forEach(tracked => this.trackOldVNew(tracked['trackName'], tracked['trackPreviousValue'], tracked['trackCurrentValue']))
        }
    }

    get trackingBasic(): Array<any> {
        return (this._trackingBasic) ? this._trackingBasic : []
    }

    get trackingCurrent(): Array<any> {
        return (this._trackingCurrent) ? this._trackingCurrent : []
    }

    get trackingOldNew(): Array<any> {
        return (this._trackingOldvNew) ? this._trackingOldvNew : []
    }

}